"use client";

import { useEffect } from 'react';
import { initializeAdjust } from '@/services/adjust';

export default function AdjustProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Adjust SDK when the app loads
    initializeAdjust();
  }, []);

  return <>{children}</>;
}